
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{staticClass:"fill-current",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 77.4 76.88","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M43.14 76.88L77.4 0 0 33.67l34.2 9.48zm26.42-69.1L44.1 64.89l-6.62-25L12 32.83z"}})])
      }
    
      }
    


//////////////////
// WEBPACK FOOTER
// ./images/icons/icon-navigation.svg
// module id = 409
// module chunks = 0